(function () {

    'use strict';

    angular.module('iplusjs.authentication', [
        'lodash',
        'moment',
        'modernizr',
        'iplusjs.config',
        'iplusjs.navigation',
        'iplusjs.utils.misc',
        'iplusjs.integration',
        'iplusjs.api'
    ])
        .run(run)
        .service('AuthenticationService', AuthenticationService)
        .service('AuthenticationInterceptor', AuthenticationInterceptor);

    run.$inject = [
        '$rootScope',
        '$http',
        '$log',
        '$window',
        'modernizr',
        'AppConfig',
        'AuthenticationService',
        'NavigationService',
        'IntegrationService',
        'ApiService',
        'ExceptionHandlerService'
    ];

    function run($rootScope, $http, $log, $window, modernizr, AppConfig, AuthenticationService, NavigationService, IntegrationService, ApiService, ExceptionHandlerService) {
        $rootScope.requests401 = [];
        $rootScope.loginInProgress = false;
        $rootScope.loginRequestsCount = 0;

        var integrationParams = IntegrationService.initIntegrationParams();

        $log.debug('integrationParams: ', integrationParams);

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (NavigationService.isEntryStep(toState.name)) {
                $rootScope.loginRequestsCount = 0;
            }
        });
        if (
            !AuthenticationService.isAuthentifiziert() ||
            integrationParams.isTokenLogin ||
            (
                !AuthenticationService.isPksLoggedIn() &&
                AuthenticationService.isTokenLogin()
            )
        ) {
            AuthenticationService.clearSession();
            onLoginRequired();
        }
        AuthenticationService.setSession(AuthenticationService.getSession(), true);
        $rootScope.$on('iplusjs:loginConfirmed', function () {
            var requests = $rootScope.requests401,
                erroStep = 'fehler.404',
                idx;

            for (idx = 0; idx < requests.length; idx++) {
                retry(requests[idx]);
            }

            $rootScope.requests401 = [];
            $rootScope.loginInProgress = false;

            function retry(req) {
                return $http(req.config).then(function (response) {
                    return req.deferred.resolve(response);
                }).catch(function (error) {
                    if (error.status !== -1) {
                        $rootScope.requests401 = [];

                        if (!modernizr.localStorage) {
                            try {
                                $window.localStorage;
                            } catch (e) {
                                if (e && e.name === 'SecurityError') {
                                    erroStep = 'fehler.cookie';
                                }
                            }
                        } else {
                            erroStep = 'fehler.404';
                        }

                        NavigationService.goToStep(erroStep, {
                            reload: false
                        });
                    }

                    return req.deferred.reject(error);
                });
            }
        });

        function onLoginRequired() {
            var payload = {
                    username: integrationParams.username || AppConfig.API.anonymUsername,
                    password: integrationParams.password || AppConfig.API.anonymPassword
                },
                erroStep = 'fehler.404';

            $rootScope.loginInProgress = true;

            AuthenticationService.login(payload).then(function (session) {
                $log.debug('LOGIN SUCCESSFUL', session);
                $rootScope.loginRequestsCount++;
                $rootScope.$broadcast('iplusjs:loginConfirmed');
            }).catch(function (error) {
                $log.debug('LOGIN FAILURE', error);
                $rootScope.loginInProgress = false;
                $rootScope.loginRequestsCount = 0;
                AuthenticationService.clearSession();
                if (error.status !== -1) {
                    if (integrationParams.isTokenLogin) {
                        erroStep = 'fehler.login';

                        ExceptionHandlerService.logRemote(error, true);

                        NavigationService.goToStep(erroStep, {
                            reload: false
                        });
                    } else {
                        ApiService.isMaintenance().then(function (isMaintenance) {
                            if (isMaintenance) {
                                erroStep = 'fehler.wartung';
                            }
                        }).finally(function () {
                            ExceptionHandlerService.logRemote(error, true);

                            NavigationService.goToStep(erroStep, {
                                reload: false
                            });
                        });
                    }
                }
            });
        }
        $rootScope.$on('iplusjs:loginRequired', function () {
            onLoginRequired();
        });
    }

    AuthenticationService.$inject = [
        '$rootScope',
        '$http',
        '$injector',
        '$window',
        'lodash',
        'modernizr',
        'moment',
        'AppConfig',
        'MiscUtilsService'
    ];
    function AuthenticationService($rootScope, $http, $injector, $window, _, modernizr, moment, AppConfig, MiscUtilsService) {
        var that = this,
            session = null,
            $sessionStorage;

        that.login = login;
        that.setSession = setSession;
        that.getSession = getSession;
        that.clearSession = clearSession;
        that.clearSessionFromSessionStorage = clearSessionFromSessionStorage;
        that.isAuthentifiziert = isAuthentifiziert;
        that.hatBerechtigung = hatBerechtigung;
        that.isTokenLogin = isTokenLogin;
        that.isPksLoggedIn = isPksLoggedIn;
        that.isLoginAllowed = isLoginAllowed;

        $sessionStorage = $injector.has('$sessionStorage') && $injector.get('$sessionStorage') || {};
        function login(credentials) {
            var serviceUrl = AppConfig.API.services.login + '?j_username=' + encodeURIComponent(credentials.username) + '&j_password=' + encodeURIComponent(credentials.password),
                session;

            return $http.post(serviceUrl, null, {
                isLoginRequest: true,
                unexpectedErrorsIgnore: true
            }).then(function (response) {
                session = _.merge(_.get(response, 'data[0]'), {
                    sessionVerifyToken: response.headers()['session-verify'],
                    tokenLoginSession: credentials.username.substr(0, AppConfig.API.tokenLoginPrefix.length) === AppConfig.API.tokenLoginPrefix,
                    timestamp: moment().valueOf()
                });

                setSession(session, true);

                return session;
            });
        }
        function setSession(sessionObj, storeIntoSessionStorage) {
            session = sessionObj;

            if (storeIntoSessionStorage) {
                $sessionStorage.session = sessionObj;
            }
        }
        function getSession() {
            return session || $sessionStorage.session || {};
        }
        function clearSession() {
            session = null;
            clearSessionFromSessionStorage();
        }
        function clearSessionFromSessionStorage() {
            delete $sessionStorage.session;
        }
        function isAuthentifiziert() {
            return MiscUtilsService.isNotEmpty(getSession());
        }
        function hatBerechtigung(berechtigung) {
            if (!isAuthentifiziert()) {
                return false;
            }

            var session = getSession();

            return session.permissions && _.find(session.permissions, {
                name: berechtigung
            });
        }
        function isTokenLogin() {
            return !!_.get(getSession(), 'tokenLoginSession');
        }
        function isPksLoggedIn() {
            if (!modernizr.localstorage) {
                return false;
            }

            return MiscUtilsService.isNotEmpty($window.localStorage.getItem('loginUser'));
        }

        function isLoginAllowed() {
            var lastLoginTimestamp = getSession().timestamp;

            if (!lastLoginTimestamp) {
                return true;
            }

            if ($rootScope.loginRequestsCount >= 3 && (moment(lastLoginTimestamp).diff(moment().valueOf(), 'seconds') * -1) < 20) {
                return false;
            }

            return true;
        }
    }

    AuthenticationInterceptor.$inject = [
        '$rootScope',
        '$q',
        '$log',
        '$injector',
        'lodash'
    ];
    function AuthenticationInterceptor($rootScope, $q, $log, $injector, _) {
        var that = this,
            regexIsHtmlPage = /\.html$|\.html\?/i;

        that.request = request;
        that.responseError = responseError;
        function request(config) {
            var AuthenticationService = $injector.get('AuthenticationService'),
                session = AuthenticationService.getSession(),
                deferred;

            $log.debug('AuthenticationInterceptor request', config);

            config.headers['Session-Verify'] = session.sessionVerifyToken;
            config.headers['Conversation-Id'] = session.conversationId;
            if (!AuthenticationService.isAuthentifiziert() && !config.isLoginRequest && !regexIsHtmlPage.test(config.url)) {
                deferred = $q.defer();

                $rootScope.$watch('loginInProgress', function (value) {
                    if (value === false) {
                        session = AuthenticationService.getSession();

                        config.headers['Session-Verify'] = session.sessionVerifyToken;
                        config.headers['Conversation-Id'] = session.conversationId;

                        deferred.resolve(config);
                    }
                });

                return deferred.promise;
            }

            return config;
        }
        function responseError(rejection) {
            var deferred,
                req,
                AuthenticationService = $injector.get('AuthenticationService');

            $log.debug('AuthenticationInterceptor responseError', rejection);

            rejection.config = rejection.config || {};

            if ((rejection.status === 401 || (rejection.status === 403 && _.get(rejection, 'data[0].cause') === 'AUTHENTICATION_FAILURE')) && !rejection.config.isLoginRequest) {
                deferred = $q.defer();
                req = {
                    config: rejection.config,
                    deferred: deferred
                };

                $rootScope.requests401.push(req);

                if (!$rootScope.loginInProgress) {
                    if (AuthenticationService.isLoginAllowed()) {
                        $rootScope.$broadcast('iplusjs:loginRequired');
                    } else {
                        return $q.reject(rejection);
                    }
                }
                return deferred.promise;
            }

            return $q.reject(rejection);
        }
    }
})();
